import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { setShowReloadMessage, showReloadMsgSelector } from 'reducers/globalSlice';
import ButtonOutline from 'components/elements/ButtonOutline';
import { useTranslation } from 'react-i18next';

const styles = {
	placement: {
		position: 'absolute',
		top: '20px',
		right: '20px'
	},
	alert: {
		display: 'flex',
		alignItems: 'center',
		'& .MuiAlert-action': {
			paddingTop: 0
		}
	},
	button: {
		color: '#fff',
		border: 'solid #fff 1px',
		textTransform: 'none'
	}
};

const MySnackbarContentWrapper = forwardRef(
	function MySnackbarContentWrapper(properties, reference) {
		return (
			<MuiAlert
				color='primary'
				elevation={6}
				ref={reference}
				variant='filled'
				sx={styles.alert}
				{...properties}
			/>
		);
	}
);

MySnackbarContentWrapper.propTypes = {
	props: PropTypes.any,
	ref: PropTypes.any
};

function AlertReload() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const reloadState = useSelector(showReloadMsgSelector);
	const dispatch = useDispatch();

	let action = '';
	let message = '';

	function logoutUser() {
		navigate('/logout');
	}

	if (reloadState.versionUpdate === 'patch') {
		message = `${t('Our system has been updated')}. ${t('Please reload')}.`;
		action = (
			<ButtonOutline
				content={t('Reload Now')}
				styles={styles.button}
				handleAction={() => window.location.reload()}
			/>
		);
	} else {
		message = `${t('Our system has been updated')}. ${t('Please re-authenticate')}.`;
		action = (
			<ButtonOutline
				content={t('Re-Authenticate Now')}
				styles={styles.button}
				handleAction={() => logoutUser()}
			/>
		);
	}
	const handleClose = (e, reason) => {
		e && e.stopPropagation();
		if (reason === 'clickaway') {
			return;
		}
		dispatch(setShowReloadMessage(false));
	};

	const renderAlertMessage = () => {
		return (
			<Box>
				<Snackbar
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'right'
					}}
					open={reloadState.isOpen}
					autoHideDuration={5000}
					sx={styles.snackBar}
					onClose={e => handleClose(e, 'clickaway')}
				>
					<MySnackbarContentWrapper
						onClose={e => handleClose(e, 'clickaway')}
						severity={'info'}
						action={action}
					>
						{message}
					</MySnackbarContentWrapper>
				</Snackbar>
			</Box>
		);
	};

	return <Box sx={styles.placement}>{renderAlertMessage()}</Box>;
}

export default AlertReload;
